// Polyfill for URL.parse
import 'core-js/actual/url/parse';

import { Grid } from '@mui/material';

import { tss } from 'tss-react/mui';

import { Or2Link } from '@/components/navigation/Or2Link';

import { Or2Image } from '@/components/image/Or2Image';

import { KEY_LOGO } from '@/components/KeyBadge/KeyAvatar';

import { graphql, type DocumentType } from '@/gql';
import { extractConnectionProps } from '@/utils/queries/queryExtracts';

const ASSISTANT_AI_RESPONSE_KNOWLEDGE_ARTICLES_RESPONSE_FRAGMENT = graphql(`
  fragment assistantAiResponseKnowledgeArticlesResponseFields on OrtooGptConversationItemResponse {
    knowledgeSourcesConnection {
      edges {
        node {
          title
          url
        }
      }
    }
  }
`);

interface Props {
  response: DocumentType<
    typeof ASSISTANT_AI_RESPONSE_KNOWLEDGE_ARTICLES_RESPONSE_FRAGMENT
  >;
}

const useStyles = tss.create(() => ({
  image: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const AssistantAiResponseKnowledgeArticles = ({ response }: Props) => {
  const { classes } = useStyles();

  const { knowledgeSourcesConnection } = response;

  const knowledgeSources = extractConnectionProps(knowledgeSourcesConnection);

  return (
    <Grid container spacing={1}>
      <Grid container direction="column" spacing={1}>
        {knowledgeSources.map((knowledgeSource, index) => {
          const { title, url } = knowledgeSource;

          let linkUrl = url;

          if (url) {
            const urlObject = URL.parse(url);
            if (urlObject) {
              urlObject.searchParams.set('gh_feature', 'assistant');
              linkUrl = urlObject.toString();
            }
          }

          return (
            <Grid container key={index} alignItems="center">
              <Grid>
                <Or2Image
                  className={classes.image}
                  src={KEY_LOGO}
                  alt="The Key Logo"
                  size={32}
                />
              </Grid>
              {linkUrl && (
                <Grid>
                  <Or2Link href={linkUrl} isExternal>
                    {title}
                  </Or2Link>
                </Grid>
              )}
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};
